// src/store/features/message/messageThunks.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import { getChatManager } from "../../middleware/chatManagerMiddleware";
import { loadMessagesSuccess } from "./messageActions";

export const initializeChatsFromDB = createAsyncThunk(
  "messages/initializeFromDB",
  async (_, { dispatch }) => {
    const chatManager = getChatManager();
    await chatManager._ensureReady();

    const allChats = chatManager.getAllChats();
    const recentChats = chatManager.getRecentChats();

    // Convert ChatManager format to Redux format
    allChats.forEach((chat) => {
      if (chat.chatMessages && chat.chatMessages.length > 0) {
        dispatch(
          loadMessagesSuccess(chat.chatMessages, chat.chatId, new Date().toISOString())
        );
      }
    });

    return { allChats, recentChats };
  }
);
